import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LandingNav from '../components/landing/LandingNav';
import Hero from '../components/landing/Hero';
import Capabilities from '../components/landing/Capabilities';
import LiveMode from '../components/landing/LiveMode';
import HowItWorks from '../components/landing/HowItWorks';
import ExamplePrompts from '../components/landing/ExamplePrompts';
import SafetyForParents from '../components/landing/SafetyForParents';
import LandingFooter from '../components/landing/LandingFooter';

const Landing = ({ onSignIn }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access');
    if (token) {
      navigate('/chat');
    }
  }, [navigate]);

  const openSignIn = typeof onSignIn === 'function' ? onSignIn : undefined;

  return (
    <div className="landing-root" id="top">
      <LandingNav onSignIn={openSignIn} />
      <main>
        <Hero onSignIn={openSignIn} />
        <Capabilities />
        <LiveMode onSignIn={openSignIn} />
        <HowItWorks />
        <ExamplePrompts onSignIn={openSignIn} />
        <SafetyForParents />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
